@if (format === TextFieldFormat.SingleLine) {
  <span>{{ value }}</span>
}
@if (format === TextFieldFormat.MultiLine) {
  <div
    [innerHTML]="value"
  style="max-height: 45px; overflow: hidden"></div>
}
